export enum LocationType {
  // special types
  MY_LOCATION = 'current',
  HOME = 'home',
  FAVORITE = 'favorite',
  GAMBIT = 'gambit',

  // new location types
  CAFE_CHESS = 'cafe_chess',
  CHESS_FRIENDLY = 'chess_friendly',
  VENUE = 'venue',
  NATURE = 'nature',

  // deprecated types
  CLUB = 'club',
  GIANT_CHESS = 'giant_chess',
  CHESS_TABLE = 'chess_table',

  // spark
  CITY = 'city',
}

export enum LocationChessFeature {
  CHESS_TABLE = 'chess_table',
  GIANT_CHESS = 'giant_chess',
  CHESS_SET = 'chess_set',
  CHESS_CLOCK = 'chess_clock',
}

export enum LocationGeneralFeature {
  ACCOMODATION = 'accomodation',
  SCHOOL = 'school',
  FOOD = 'food',
  DRINKS = 'drinks',
  NOISY = 'noisy',
  CALM = 'calm',
  CASUAL = 'casual',
  PROFESSIONAL = 'professional',
  TERRACE = 'terrace',
  ART = 'art',
  CLUBBING = 'clubbing',
  LIVE_MUSIC = 'live_music',
  VIEW = 'view',
  PARK = 'park',
  WATER = 'water',
}

export enum MapLocationType {
  LOCATION = 'location',
  GAMBIT = 'gambit',
  CLUB = 'club',
  CLUSTER = 'cluster',
}

export enum MapLocationSource {
  INTERNAL = 'internal',
  EXTERNAL = 'external',
  GOOGLE = 'google_maps',
}
